import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import { 
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter,
    ListGroup, 
    ListGroupItem,  } from 'reactstrap';

export default class ModalDetail extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.modal_data !== null) {
      return true;
    }
    return false
  }

  RenderImage(img_src) {
      const {modal_data} = this.props;
      let image = modal_data.Photos.results;

      let imageList = [];
      if(image.length === 0) {
          return (
              <img className="img-null-owl" src="https://dummyimage.com/235x220/4d494d/686a82.gif&text=placeholder+image" alt="Loading"/>
          )
      } else {
          for(let i = 0; i < image.length; i++){
              imageList.push(
                  <div key={i}><img className="img-responsive-owl" src={`${image[i].URL}&token=${this.props.userReducer.token}`} alt={image[i].Alias}/></div>
              )
          }
      }
      return imageList;
  }

  render() {
    const {modal_data} = this.props;
    if(modal_data === null) return null

    return (
      <Modal isOpen={this.props.is_toggle} toggle={()=>this.props.toggleModal(modal_data)} className="modal-lg">
          <ModalHeader toggle={()=>this.props.toggleModal(modal_data)}>{modal_data.Name}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-8">
                <div className="list-separator"><div className="item-inner">Asset Information</div></div>
                <ListGroup>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Asset Alias</strong></div>
                    <div className="col-md-8"><span>{modal_data.Alias}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Asset</strong></div>
                    <div className="col-md-8"><span>{modal_data.Name}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Tag</strong></div>
                    <div className="col-md-8"><span>{modal_data.Tag ? modal_data.Tag : '-'}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Assigned</strong></div>
                    <div className="col-md-8"><span>{modal_data.Owner.FirstName}</span>&nbsp;<span>{modal_data.Owner.LastName}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Status</strong></div>
                    <div className="col-md-8"><span>{modal_data.Status.Name}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Type</strong></div>
                    <div className="col-md-8"><span>{modal_data.Type.Name}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Site</strong></div>
                    <div className="col-md-8"><span>{modal_data.Site.Name}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Location</strong></div>
                    <div className="col-md-8"><span>{modal_data.Location.Name}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="list-border-bottom">
                    <div className="col-md-4"><strong className="spaceRRR">Max Days</strong></div>
                    <div className="col-md-8"><span>{modal_data.MaxDay}</span></div>
                  </ListGroupItem>
                  <ListGroupItem className="no-border">
                    <div className="col-md-12"><strong className="spaceRRR">Description</strong></div>
                    <div className="col-md-12"><span>{modal_data.Description}</span></div>
                  </ListGroupItem>
                </ListGroup>
              </div>
              <div className="col-md-4">
                <OwlCarousel className="owl-theme" items={1} dots={false} margin={5} nav>
                  {this.RenderImage()}
                </OwlCarousel>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
              <button type="button" onClick={()=>this.props.toggleModal(modal_data)} className="btn btn-danger">Close</button>
          </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/report/helper/component/Modal/ModalDetail.js